import React, { useEffect } from "react";
import injectScript from "src/common/utils/injectScript";
import { buildPaypalSdkUrl } from "src/client/js/view/utils/buildPaypalSdkUrl";
import {
  useMediaQueries,
  useCountry,
  useModel,
  useGlobalContent,
} from "src/client/js/view/hooks";

export const PayPalMessage = () => {
  const { topology } = useModel();
  const country = useCountry();
  const { payLaterMessage } = useGlobalContent("checkout");
  const mobile = useMediaQueries("mobile");

  const getTextAlign = () => {
    if (mobile) {
      return "center";
    }
    return "left";
  };

  //DOC for styling options: https://developer.paypal.com/docs/business/pay-later/gb/integrate/reference/

  const style = {
    layout: "text",
    text: {
      align: getTextAlign,
    },
    logo: {
      position: "left",
    },
  };

  useEffect(() => {
    injectScript(
      buildPaypalSdkUrl(topology.paypal?.clientId, country, payLaterMessage),
      () => {
        window.paypal
          // eslint-disable-next-line new-cap
          .Messages({
            style,
            buyerCountry: country.iso,
          })
          .render("#pp-pay-later-message");
      }
    );
  }, []);

  return (
    <div className="PayPalMessage">
      <div id="pp-pay-later-message" />
    </div>
  );
};

export default PayPalMessage;
